// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemLabel_wrapper__bkFDo"};